import { useState, useEffect } from 'react';
import DMTHistory from './history';
import DmtHome from '../dmtHomeExpress/index';
import RefundHistory from './refund';
import { Tabs, Typography } from 'antd';

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;

const MyComponent = () => {
    // const history = useHistory();
    const tabPosition = 'top';
    const [defaultKey, setDefaultKey] = useState("1");

    useEffect(() => {

    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeHandler = (value) => {
        setDefaultKey(value);
    }

    // Title section that sits on the right of the tab row
    const rightTitleSection = (
        <div style={{ paddingRight: 8, textAlign: 'right', lineHeight: 1.2 }}>
            <Title
                level={3}
                style={{
                    margin: 0,
                    color: '#C9262C',
                    fontWeight: 700,
                    letterSpacing: '-0.4px',
                    fontSize: 28,
                    display: 'inline-block',
                    borderBottom: '3px solid #C9262C',
                    paddingBottom: 6,
                }}
            >
                Airtel DMT
            </Title>
        </div>
    );

    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='card rounded-0 p-3'>
                                    <Tabs
                                        defaultActiveKey={defaultKey}
                                        tabPosition={tabPosition}
                                        onTabScroll={"right"}
                                        onChange={(key) => onChangeHandler(key)}
                                        tabBarExtraContent={{ right: rightTitleSection }}
                                    >
                                        <TabPane tab={`Home`} key="1">
                                            <div className='h-100'>
                                                <DmtHome />
                                            </div>
                                        </TabPane>
                                        <TabPane tab={`History`} key="4">
                                            <div className='h-100'>
                                                <DMTHistory />
                                            </div>
                                        </TabPane>
                                        <TabPane tab={`Refund`} key="5">
                                            <div className='h-100'>
                                                <RefundHistory />
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MyComponent;